export default [
    {
        id: 1,
        img: "assets/lunch-time.svg",
        title: "Mess timing",
        href: "/mess_timing"
    },
    {
        id: 2,
        href: "/messmenu",
        img: "assets/diet.svg",
        title: "Mess Menu"
    },
    {
        id: 3,
        href: "/timetable",
        img: "assets/timetable.svg",
        title: "Time Table"
    },
    {
        id: 4,
        href: "/holidays",
        img: "assets/schedule.svg",
        title: "Holidays"
    },
    {
        id: 5,
        href: "/pyq",
        img: "assets/exam.svg",
        title: "PYQ"
    },
    {
        id: 6,
        href: "/syllabus",
        img: "assets/checklist.svg",
        title: "Syllabus"
    },
    {
        id: 7,
        href: "/students",
        img: "assets/studentData.svg",
        title: "Student Data",
        isAdminCard: true
    }
]
